import React from "react";
import {
  CircularProgress,
  ClickAwayListener,
  Divider,
  Paper,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import styled from "styled-components";
import useRoleTeamMembers from "../../swr/hooks/Roles/useRoleTeamMembers";

const Wrapper = styled(Paper)`
  min-width: 180px;
  min-height: 130px;
  padding: 10px;
  border: 2px solid #eeeeee;
  text-align: left;
`;

const ShowDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  max-height: 240px;
  overflow-y: scroll;
  border-radius: 4px;
  padding: 6px 0px;
`;

const CenterCircular = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  minheight: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SubtitleSpan = styled.span`
  font-size: 11px;
  color: ${(props) => props.theme.palette.grey[500]};
`;

const LinkSpan = styled(Link)`
  text-decoration: none;
  margin-top: 12px;
  display: block;

  &:active {
    text-decoration: none;
    color: ${(props) => props.theme.palette.primary.dark};
  }

  &:visited {
    text-decoration: none;
    color: ${(props) => props.theme.palette.primary.dark};
  }

  &:hover {
    text-decoration: underline;
  }

  span {
    font-size: 10px;
    color: ${(props) => props.theme.palette.primary.dark};
  }
`;

const Inner = ({ id, name, setOpen, shouldLinkToRolePage }) => {
  const { isError, isLoading, teamMembers } = useRoleTeamMembers(id);

  if (isError) {
    return (
      <Wrapper>
        <span>Error loading Role details</span>
      </Wrapper>
    );
  }

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Wrapper>
        <Typography variant="subtitle2" sx={{ mb: -1 }}>
          {name}
        </Typography>
        <SubtitleSpan>
          Team Members {isLoading ? "" : `(${teamMembers.length})`}
        </SubtitleSpan>
        <Divider sx={{ mb: 3 }} />
        {isLoading ? (
          <CenterCircular>
            <CircularProgress size={16} sx={{ color: "black" }} />
          </CenterCircular>
        ) : (
          <ShowDiv>
            {teamMembers.length > 0 ? (
              teamMembers.map((member) => (
                <div key={member.userId}>
                  <span>{`${member.firstName} ${member.lastName}`}</span>
                </div>
              ))
            ) : (
              <div style={{ padding: 2 }}>
                <span style={{ fontSize: 10 }}>No team members</span>
              </div>
            )}
          </ShowDiv>
        )}
        {!isLoading && shouldLinkToRolePage && (
          <LinkSpan to={`/roles/details/${id}`}>
            <span>View Role Details</span>
          </LinkSpan>
        )}
      </Wrapper>
    </ClickAwayListener>
  );
};

export default Inner;
